export enum ButtonSvgIcon {
  Account = '/assets/icons/account.svg',
  AddOn = '/assets/icons/add-on.svg',
  ArrowDown = '/assets/icons/arrow-down.svg',
  ArrowUp = '/assets/icons/arrow-up.svg',
  Check = '/assets/icons/check.svg',
  Company = '/assets/icons/company.svg',
  Delete = '/assets/icons/delete.svg',
  Edit = '/assets/icons/edit.svg',
  Email = '/assets/icons/email.svg',
  Group = '/assets/icons/group.svg',
  H1 = '/assets/icons/h1.svg',
  H2 = '/assets/icons/h2.svg',
  Information = '/assets/icons/info.svg',
  Location = '/assets/icons/location.svg',
  Plus = '/assets/icons/plus.svg',
  Store = '/assets/icons/store.svg',
}
